import { CONTENT_GROUP } from 'app/constants/AnalyticsGa4Constants';

export function getContentGroup(currentUrl) {
  switch (true) {
    case currentUrl.startsWith('/v2/accountmessages'):
      return CONTENT_GROUP.BORROWING_LIBRARY_MESSAGES;

    case currentUrl.startsWith('/v2/browse'): {
      if (currentUrl === '/v2/browse') {
        return CONTENT_GROUP.BROWSE_HOME;
      }
      if (currentUrl.startsWith('/v2/browse/titles/new')) {
        return CONTENT_GROUP.BROWSE_TITLES_NEW;
      }
      if (currentUrl.startsWith('/v2/browse/titles/onorder')) {
        return CONTENT_GROUP.BROWSE_TITLES_ON_ORDER;
      }
      if (
        currentUrl.startsWith('/v2/browse/collection') ||
        currentUrl.startsWith('/v2/browse/format') ||
        currentUrl.startsWith('/v2/browse/genre')
      ) {
        return CONTENT_GROUP.BROWSE_CATEGORY;
      }
      return undefined;
    }

    case currentUrl.startsWith('/v2/checkedout'):
      return CONTENT_GROUP.BORROWING_CHECKED_OUT;

    case currentUrl.startsWith('/v2/comment/'):
      return CONTENT_GROUP.COMMUNITY_CONTENT_COMMENT;

    case currentUrl.startsWith('/v2/fines'):
      return CONTENT_GROUP.BORROWING_FEES;

    case currentUrl.startsWith('/v2/interlibraryloans'):
      return CONTENT_GROUP.BORROWING_ILL_REQUESTS;

    case currentUrl.startsWith('/v2/list/display'):
      return CONTENT_GROUP.LIST;

    case currentUrl.startsWith('/v2/locations'):
      return CONTENT_GROUP.LOCATION_LISTING;

    case currentUrl.startsWith('/v2/quotation/'):
      return CONTENT_GROUP.COMMUNITY_CONTENT_QUOTATION;

    case currentUrl.startsWith('/v2/recentlyreturned'):
      return CONTENT_GROUP.BORROWING_HISTORY;

    case currentUrl.startsWith('/v2/record/'): {
      const segments = currentUrl.split('/').filter(Boolean);
      if (segments.length === 3) {
        return CONTENT_GROUP.BIB;
      }
      const lastSegment = segments[3];
      const groupMapping = {
        lists: CONTENT_GROUP.BIB_LIST,
        recommendations: CONTENT_GROUP.BIB_RECOMMENDATION,
        comments: CONTENT_GROUP.BIB_COMMENT,
        quotations: CONTENT_GROUP.BIB_QUOTATION,
        summaries: CONTENT_GROUP.BIB_SUMMARY,
        videos: CONTENT_GROUP.BIB_VIDEO,
        contentnotices: CONTENT_GROUP.BIB_CONTENT_NOTICE,
        reviews: CONTENT_GROUP.BIB_REVIEW
      };
      return groupMapping[lastSegment];
    }

    case currentUrl.startsWith('/v2/search'):
      return CONTENT_GROUP.CATALOG_SEARCH;

    case currentUrl.startsWith('/v2/summary/'):
      return CONTENT_GROUP.COMMUNITY_CONTENT_SUMMARY;

    case currentUrl.startsWith('/v2/users/') && currentUrl.endsWith('/shelves/completed'):
      return CONTENT_GROUP.SHELVES_COMPLETED;

    case currentUrl.startsWith('/v2/users/') && currentUrl.endsWith('/shelves/for_later'):
      return CONTENT_GROUP.SHELVES_FOR_LATER;

    case currentUrl.startsWith('/v2/users/') && currentUrl.endsWith('/shelves/in_progress'):
      return CONTENT_GROUP.SHELVES_IN_PROGRESS;

    case currentUrl.startsWith('/v2/video/'):
      return CONTENT_GROUP.COMMUNITY_CONTENT_VIDEO;

    case currentUrl.startsWith('/v2/events'): {
      if (currentUrl.startsWith('/v2/events/account')) {
        return CONTENT_GROUP.USER_ACCOUNT_EVENT;
      }
      if (currentUrl === '/v2/events') {
        return CONTENT_GROUP.EVENT_LISTING;
      }
      if (!currentUrl.startsWith('/v2/events/pdf')) {
        return CONTENT_GROUP.EVENT;
      }
      return undefined;
    }

    case currentUrl.startsWith('/v2/holds'):
      return CONTENT_GROUP.BORROWING_ON_HOLD;

    default:
      return undefined;
  }
}
